import { APP_SETTINGS } from "src/environments/environment";
import { DatePipe } from "@angular/common";
import { AfterContentInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { CentroCusto } from "src/app/models/centrocusto.model";
import { EncarregadoCB } from "src/app/models/encarregadoCB.model";
import { UsuarioCB } from "src/app/models/usuario-cb.model";
import { Funcionario } from "src/app/models/funcionario.model";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { AreaTecnicaService } from "src/app/pages/cadastros/areatecnica/areatecnica.service";
import { EmpreiteiraService } from "src/app/pages/cadastros/empreiteira/empreiteira.service";
import { CentroCustoService } from "src/app/services/centro.custo.service";
import { GrupoLocalNivelService } from "src/app/services/grupo-local-nivel.service";
import { LocalService } from "src/app/services/local.service";
import { OSService } from "src/app/services/os-service";
import { UsuarioService } from "src/app/services/usuario.service";
import { SCAMP_API, SCAMP_API_RPT } from "src/environments/environment";
import { FuncionarioService } from "../../cadastros/funcionario/funcionario.service";
import { GrupoLocalNivel1 } from "../../domain/domain.model";
import { EquipamentoComboBoxViewModel } from "../../domain/viewmodels.models";
import { EquipamentoService } from "./../../../services/equipamento.service";

@Component({
  selector: "app-consultar-os",
  templateUrl: "./consultar-os.component.html",
  styleUrls: ["./consultar-os.component.scss"],
  providers: [
    AreaTecnicaService,
    LocalService,
    EmpreiteiraService,
    OSService,
    FuncionarioService,
  ],
})
export class ConsultarOsComponent implements OnInit, AfterContentInit {
  // Fontes ComboBox
  areasTecnicasCB: any;
  locaisCB: any;
  empreiteirasCB: any;
  niveis1: GrupoLocalNivel1[] = [];
  encarregados: EncarregadoCB[] = [];
  usuarios: UsuarioCB[] = [];
  funcionarios: Funcionario[] = [];

  // Variaveis de controle
  resultadosPesquisa: any[] = [];
  validacaoDatas = "";
  validacaoComboTipoDeData = "";

  nenhumResultado = false;

  parametrosDeBusca: any = undefined;
  excelFileName: string = "";
  hrefExcelFile: string = "";

  equipamentos: EquipamentoComboBoxViewModel[] = [];
  centrosDeCusto: CentroCusto[] = [];
  isProcessing: boolean = false;

  form: FormGroup;

  public autorizacoes: UsuarioAutorizacoes;
  public autorizacaoEditarOS: boolean = false;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  tipoOSFixas: any[] = [];
  tipoOSAdicionais: any[] = [];
  tipoOSPreventivas: any[] = [];

  constructor(
    private areatecnicaService: AreaTecnicaService,
    private localService: LocalService,
    private empreiteiraService: EmpreiteiraService,
    private osservice: OSService,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private funcionarioService: FuncionarioService,
    private equipamentoService: EquipamentoService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private centroCustoService: CentroCustoService,
    private grupoLocalNivelService: GrupoLocalNivelService,
    private osService: OSService,
  ) {}

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota(
      "consultar-os-emitida",
    );
    this.autorizacaoEditarOS =
      this.usuarioService.getAutorizacoesEspecificaPorRota(
        "consultar-os-emitida",
        "editar-os",
      );
  }

  ngOnInit() {
    this.resetForm();
    this.getCentroCustos();
    this.getColaboradores();
    this.getUsuariosSolicitantes();
    this.getAllGrupoLocalNivel1();
    this.getTiposOSs();

    // Popula ComboBoxes
    this.areatecnicaService
      .getAreasTecnicas()
      .subscribe((response) => (this.areasTecnicasCB = response));

    this.empreiteiraService.getEmpreiteiras().subscribe((response) => {
      this.empreiteirasCB = response;

      if (this.empreiteirasCB.length === 1) {
        this.form.controls.empreiteiraId.setValue(this.empreiteirasCB[0].id); // caso só haja uma empreiteira, já define seu valor
      }
    });
  }

  resetForm() {
    this.form = this.formBuilder.group({
      areaTecnicaId: [""],
      localId: [""],
      status: [""],
      empreiteiraId: [""],
      tipoDeData: ["E"],
      dataInicial: [this.datePipe.transform(new Date(), "yyyy-MM-dd")],
      dataFinal: [this.datePipe.transform(new Date(), "yyyy-MM-dd")],
      equipamentoId: [""],
      tipoOS: [""],
      oSId: [""],
      sSId: [""],
      pTId: [""],
      centroCustoDescricao: [""],
      centroCustoId: [""],
      usuarioSolicitouId: [""],
      colaboradorId: [""],
      grupoLocalNivel1Id: [""],
    });
  }

  getTiposOSs() {
    this.osService.GetTiposOSs().subscribe((response: any[]) => {
      if (response) {
        this.tipoOSFixas = response.filter((x) => x.tipo === "F");
        this.tipoOSAdicionais = response.filter((x) => x.tipo === "A");
        this.tipoOSPreventivas = response.filter((x) => x.tipo === "P");
      }
    });
  }

  getAllGrupoLocalNivel1() {
    this.grupoLocalNivelService
      .getAllGrupoLocalNivel1()
      .subscribe((response: GrupoLocalNivel1[]) => {
        this.niveis1 = response;

        if (this.niveis1.length === 1) {
          this.form.get("grupoLocalNivel1Id").setValue(this.niveis1[0].id);
          this.changeGrupoLocalNivel1(this.niveis1[0].id);
        } else {
          this.form.get("grupoLocalNivel1Id").setValue("");
          this.locaisCB = [];
          this.equipamentos = [];
        }
      });
  }

  changeGrupoLocalNivel1(localId = null) {
    this.locaisCB = [];
    this.equipamentos = [];

    const grupoLocalNivel1Id = Number(
      this.form.get("grupoLocalNivel1Id").value,
    );

    if (grupoLocalNivel1Id > 0) {
      this.localService
        .getLocaisByGroupLevelOne(grupoLocalNivel1Id)
        .subscribe((response) => {
          this.locaisCB = response;

          if (localId != null) {
            if (this.locaisCB.length == 1) {
              this.form.get("localId").setValue(this.locaisCB[0].id);
              this.getEquipamentoPorLocalId(this.locaisCB[0].id);
            } else {
              this.form.get("localId").setValue("");
            }
          } else {
            this.form.get("localId").setValue("");
          }
        });
    }
  }

  getUsuariosSolicitantes() {
    this.usuarioService.getUsuariosCB().subscribe(
      (response) => {
        this.usuarios = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Usuarios Solicitantes");
      },
    );
  }
  getColaboradoresAntes() {
    this.funcionarioService.getFuncionarios().subscribe(
      (response) => {
        this.funcionarios = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter funcionários Colaboradores");
      },
    );
  }
  getColaboradores() {
    this.funcionarioService.getListaFuncionarios().subscribe(
      (response) => {
        this.funcionarios = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter funcionários Colaboradores");
      },
    );
  }

  getCentroCustos() {
    this.centroCustoService.getCentrosCustos().subscribe(
      (response: CentroCusto[]) => {
        this.centrosDeCusto = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter lista de Centros Custos");
      },
    );
  }

  getEquipamentoPorLocalId(parameterLocalId: number) {
    const localId = Number(parameterLocalId);

    if (localId == 0) {
      this.setFormEquipamento("");
      this.equipamentos = [];
    }

    this.equipamentoService
      .getEquipamentosPorLocalId(localId)
      .subscribe((response: EquipamentoComboBoxViewModel[]) => {
        this.equipamentos = response;
        if (this.equipamentos.length == 1) {
          this.setFormEquipamento(this.equipamentos[0].id);
        } else {
          this.setFormEquipamento("");
        }
      });
  }

  private setFormEquipamento(id) {
    this.form.get("equipamentoId").setValue(id);
  }

  submit() {
    this.excelFileName = "";
    this.hrefExcelFile = "";

    Object.keys(this.form.controls).forEach((key) => {
      this.form.controls[key].markAsTouched();
    });

    this.validaDatas(
      this.form.controls.dataInicial.value,
      this.form.controls.dataFinal.value,
    );
    this.validaComboTipoDados(this.form.controls.tipoDeData.value);

    if (this.validacaoDatas === "" && this.validacaoComboTipoDeData === "") {
      this.destacar(); // destaca campo selecionados como parâmetros
      this.isProcessing = true;
      this.nenhumResultado = false;

      this.osservice.consultarOSs(this.form.value).subscribe(
        (response) => {
          this.resultadosPesquisa = response;

          if (this.resultadosPesquisa.length === 0) {
            this.nenhumResultado = true;
          }
          this.isProcessing = false;
        },
        (err: any) => {
          this.toastr.error(err, "Ocorreu um erro ao tentar fazer a pesquisa");
          this.isProcessing = false;
          this.reset();
        },
      );
    }
  }

  reset() {
    // resete todos os campos
    const selects = document.getElementsByTagName("select");
    const inputs = document.getElementsByTagName("input");

    this.resetForm();

    Array.from(selects).forEach((s) => (s.value = ""));
    Array.from(inputs).forEach((i) => (i.value = ""));

    // retira o destaque de qualquer campo
    this.destacar();

    // reseta as variaveis de controle
    this.validacaoDatas = "";
    this.validacaoComboTipoDeData = "";
    this.isProcessing = false;
    this.resultadosPesquisa = [];
    this.nenhumResultado = false;

    this.parametrosDeBusca = undefined;
    this.excelFileName = "";
    this.hrefExcelFile = "";
  }

  clearNumeroOS() {
    this.form.get("oSId").setValue("");
    this.destacar();
    this.submit();
  }

  clearSSId() {
    this.form.get("sSId").setValue("");
    this.destacar();
    this.submit();
  }
  clearPTId() {
    this.form.get("pTId").setValue("");
    this.destacar();
    this.submit();
  }

  searchByKeys(key: string) {
    if (key == "os") {
      this.form.get("sSId").setValue("");
      this.form.get("pTId").setValue("");
    }

    if (key == "ss") {
      this.form.get("oSId").setValue("");
      this.form.get("pTId").setValue("");
    }

    if (key == "pt") {
      this.form.get("oSId").setValue("");
      this.form.get("sSId").setValue("");
    }

    this.submit();
  }

  validaComboTipoDados(td: string) {
    this.validacaoComboTipoDeData = "";
    if (td === "") {
      this.validacaoComboTipoDeData = "informe o tipo de data";
    }
  }

  validaDatas(dataInicial, dataFinal) {
    this.validacaoDatas = "";

    if (dataInicial === "" && dataFinal === "") {
      this.validacaoDatas = "O período deve ser informado";
    }

    if (!(dataInicial === "" && dataFinal === "")) {
      if (dataInicial === "" && dataFinal !== "") {
        this.validacaoDatas = "Informe a Data Inicial";
      }
      if (dataInicial !== "" && dataFinal === "") {
        this.validacaoDatas = "Informe a Data Final";
      }
      if (Date.parse(dataFinal) < Date.parse(dataInicial)) {
        this.validacaoDatas = "A data final deve ser maior que data inicial";
      }
    }
  }

  exportarToPdf() {
    var osIds: any[] = [];

    this.resultadosPesquisa.forEach((item) => {
      osIds.push(item.id);
    });

    this.isProcessing = true;

    this.osservice.imprimirOs(osIds.toString()).subscribe(
      (response) => {
        if (response.success === true) {
          if (response.nenhumResultado === false) {
            window.open(
              `${SCAMP_API_RPT.root}${response.pathRpt}`,
              "_blank",
              "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no",
            );
          } else {
            this.toastr.warning(response.msgErro);
          }
        } else {
          this.toastr.error(response.msgErro);
        }
        this.isProcessing = false;
      },
      (err: any) => {
        this.toastr.error(
          "Não foi possível se conectar ao servidor de relatórios",
          "Erro de Conexão",
        );
        this.isProcessing = false;
      },
    );
  }

  exportarToExcel() {
    this.osservice.exportarToExcel(this.form.value).subscribe((response) => {
      if (response.success === true) {
        if (response.nenhumResultado === false) {
          this.excelFileName = response.fileName;
          this.hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`;
        } else {
          this.toastr.warning(response.msgErro);
        }
      } else {
        this.toastr.error(response.msgException);
      }
    });
  }

  removeLinkExcel() {
    this.excelFileName = "";
    this.hrefExcelFile = "";
  }

  exportarMaterial() {
    var osIds: any[] = [];

    this.resultadosPesquisa.forEach((item) => {
      osIds.push(item.id);
    });

    this.isProcessing = true;

    this.osservice.getMaterialUtilizadoExcel(osIds.toString()).subscribe(
      (response) => {
        if (response.success === true) {
          this.isProcessing = false;

          if (response.nenhumResultado === false) {
            this.excelFileName = response.fileName;
            this.hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`;
          } else {
            this.toastr.warning(response.msgErro);
          }
        } else {
          this.toastr.error(response.msgException);
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false;
      },
    );
  }

  exportarFuncionario() {
    var osIds: any[] = [];

    this.resultadosPesquisa.forEach((item) => {
      osIds.push(item.id);
    });

    this.isProcessing = true;

    this.osservice.imprimirOSFuncionarioAtuante(osIds.toString()).subscribe(
      (response) => {
        if (response.success === true) {
          if (response.nenhumResultado === false) {
            window.open(
              `${SCAMP_API_RPT.root}${response.pathRpt}`,
              "_blank",
              "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no",
            );
          } else {
            this.toastr.warning(response.msgErro);
          }
        } else {
          this.toastr.error(response.msgErro);
        }
        this.isProcessing = false;
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false;
      },
    );
  }

  destacar() {
    const selects = document.getElementsByTagName("select");
    const inputs = document.getElementsByTagName("input");

    Array.from(selects).forEach((s) => s.classList.remove("has-param"));
    Array.from(inputs).forEach((i) => i.classList.remove("has-param"));

    if (
      this.form.get("oSId").value != "" ||
      this.form.get("sSId").value != "" ||
      this.form.get("pTId").value != ""
    ) {
      let keyId = undefined;

      if (this.form.get("oSId").value != "") {
        keyId = document.getElementById("oSId");
      }

      if (this.form.get("sSId").value != "") {
        keyId = document.getElementById("sSId");
      }

      if (this.form.get("pTId").value != "") {
        keyId = document.getElementById("pTId");
      }

      keyId.classList.add("has-param");
    } else {
      Array.from(selects).forEach((s) => {
        if (s.value !== "") {
          s.classList.add("has-param");
        }
      });
      Array.from(inputs).forEach((i) => {
        if (i.value !== "") {
          i.classList.add("has-param");
        }
      });
    }
  }

  limparDataListCentroCustos() {
    this.form.get("centroCustoDescricao").setValue("");
    this.form.get("centroCustoId").setValue("");
  }

  changeDataListCentroCustos(value: string) {
    let item;
    if (value != "") {
      item = this.centrosDeCusto.filter((t) =>
        t.nome.toLowerCase().includes(value.toLowerCase()),
      )[0];
    }
    if (item != undefined) {
      this.form.get("centroCustoDescricao").setValue(item.nome);
      this.form.get("centroCustoId").setValue(item.id);
    } else {
      this.form.get("centroCustoDescricao").setValue("");
      this.form.get("centroCustoId").setValue("");
    }
  }

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) {
      msg = "A aplicação não conseguiu se conectar ao Servidor";
    }
    if (Number(exception.status) === 500) {
      msg = "O Servidor gerou um erro de processamento";
    }
    this.toastr.error(
      `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`,
    );
  }
}
